module.exports = __webpack_public_path__ + "assets/img/u3153.0a2cf9e0.png";